import { useQuery } from "@tanstack/react-query";
import api from "@/services/api";
import type { VendorResponse } from "@byk/shared";

export function useVendors() {
  return useQuery({
    queryKey: ["vendors"],
    queryFn: async () => {
      const response = await api.get<{ data: VendorResponse[] }>("/api/vendors");
      return response.data.data;
    },
    staleTime: 1000 * 60 * 10, // 10 minutes
  });
}

export function useVendor(id: string) {
  return useQuery({
    queryKey: ["vendors", id],
    queryFn: async () => {
      const response = await api.get<{ data: VendorResponse }>(`/api/vendors/${id}`);
      return response.data.data;
    },
    enabled: !!id,
    staleTime: 1000 * 60 * 10,
  });
}

export default useVendors;
